import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';
import { Box, TextField, Button, InputAdornment, Typography } from '@material-ui/core';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import Icon from 'sharedComponents/Icon';
import { validationSchema, initialValues } from 'forms/loginForm';

import useStyles from './useStyles';

const LoginForm = props => {
  const { t } = useTranslation();
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const classes = useStyles();

  const { onSubmit, isLoggingIn } = props;

  const formik = useFormik({
    validationSchema,
    initialValues,
    onSubmit,
  });

  const { errors, values, handleChange, handleSubmit, isSubmitting, handleBlur, touched } = formik;

  const isAbleToSubmit = !isSubmitting && isEmpty(errors);

  const handleClickShowPassword = () => setPasswordVisible(!isPasswordVisible);

  return (
    <Box className={classes.paper}>
      <form className={classes.form} noValidate onSubmit={handleSubmit}>
        <TextField
          error={touched.email && (Boolean(errors.email) || Boolean(errors.serverError))}
          helperText={touched.email && t(errors.email)}
          variant="outlined"
          id="email"
          name="email"
          type="email"
          placeholder={t('components.LoginForm.email')}
          autoComplete="email"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.email}
          className={classes.field}
        />
        <TextField
          error={touched.password && (Boolean(errors.password) || Boolean(errors.serverError))}
          helperText={touched.password && t(errors.password)}
          variant="outlined"
          name="password"
          type={isPasswordVisible ? 'text' : 'password'}
          id="password"
          placeholder={t('components.LoginForm.password')}
          autoComplete="new-password"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.password}
          className={classes.field}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {isPasswordVisible ? (
                  <Icon name="visible" onClick={handleClickShowPassword} className={classes.visibilityIcon} />
                ) : (
                  <Icon name="visibleOff" onClick={handleClickShowPassword} className={classes.visibilityIcon} />
                )}
              </InputAdornment>
            ),
          }}
        />
        {errors.serverError && (
          <Typography className={classes.error} variant="subtitle1" color="error">
            {errors.serverError}
          </Typography>
        )}
        <Button className={classes.button} type="submit" disabled={!isAbleToSubmit || isLoggingIn}>
          {t('components.LoginForm.button')}
        </Button>
      </form>
    </Box>
  );
};

LoginForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isLoggingIn: PropTypes.bool,
};

LoginForm.defaultProps = {
  isLoggingIn: false,
};

export default LoginForm;



// WEBPACK FOOTER //
// ./src/sharedComponents/LoginForm/LoginForm.js